import SalarieMail from '@/generated/controls/salarie/SalarieMail.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: SalarieMail
})
